import React, { useContext } from 'react';
import { Box } from "@mui/system";
import { Button } from "@mui/material";
import { LayoutContext } from "../../contexts/LayoutContext/LayoutContext";
import { socialMediaIcons } from "../../displayConfig";
import { SpotifyIcon } from "../../media/platform-icons/music-platforms/SpotifyIcon";
import paypalIcon from '../../media/paypal_icon.png';
import {
    followOnFacebookCits,
    followOnInstagramCits,
    followOnTikTokCits,
    followOnTwitterCits,
    followOnYouTubeCits,
    paypalDonateLink,
    spotifyCits,
} from "../../config";

const iconSize = 50;

const DonatePaypalButton = () => {
    const { isMobile } = useContext(LayoutContext);

    return (
        <Button
            variant="outlined"
            size="small"
            onClick={() => window.open(paypalDonateLink)}
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: '#1f1f1f',
                color: '#fff',
                fontWeight: 'bolder',
                border: 'none',
                height: iconSize,
                width: iconSize,
                minWidth: iconSize,
                padding: 0,
                fontSize: 7,
                '& img': {
                    filter: 'grayscale(100%) invert(100%)',
                },
                '&:hover': {
                    backgroundColor: '#1f1f1f',
                    color: '#fff',
                    border: 'none',
                },
            }}
        >
            <img src={paypalIcon} alt="PayPal" style={{ width: 25, height: 25 }} />
            Donate
        </Button>
    );
};

export const SocialMediaIconsRow = ({
                                        width = '50%',
                                        iconSize: customIconSize = 50,
                                        spacing = 'space-between',
                                        marginBottom = 1,
                                        customSocialMedia = null,
                                        containerSx = {},
                                        iconColor = null,
                                        showLabels = false,
                                        labelColor = '#fff',
                                    }) => {
    const { isMobile } = useContext(LayoutContext);

    // Default social media configuration
    const defaultSocialMedia = [
        { icon: <SpotifyIcon size={customIconSize} />, link: spotifyCits, label: 'Spotify' },
        { icon: socialMediaIcons.instagram, link: followOnInstagramCits, label: 'Instagram' },
        { icon: socialMediaIcons.youTube, link: followOnYouTubeCits, label: 'YouTube' },
        { icon: socialMediaIcons.facebook, link: followOnFacebookCits, label: 'Facebook' },
        // { icon: socialMediaIcons.twitter, link: followOnTwitterCits, label: 'Twitter' },
        // { icon: socialMediaIcons.tikTok, link: followOnTikTokCits, label: 'TikTok' },
        // { component: <DonatePaypalButton />, label: 'Donate' },
    ];

    // Use custom social media if provided, otherwise use default
    const socialMedia = customSocialMedia || defaultSocialMedia;

    // Apply icon color if provided
    const getIconWithColor = (icon) => {
        if (!iconColor) return icon;
        return React.cloneElement(icon, {
            color: iconColor,
            size: customIconSize
        });
    };

    return (
        <Box
            sx={{
                width: isMobile ? '100%' : width,
                display: 'flex',
                justifyContent: spacing,
                marginBottom: marginBottom,
                ...containerSx
            }}
            zIndex={2}
        >
            {socialMedia.map((item, index) => (
                item.component ? (
                    <div key={index} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        {item.component}
                        {showLabels && (
                            <span style={{
                                color: labelColor,
                                fontSize: '10px',
                                marginTop: '4px',
                                fontWeight: 'bold'
                            }}>
                                {item.label || 'Donate'}
                            </span>
                        )}
                    </div>
                ) : (
                    <a
                        href={item.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        key={index}
                        style={{
                            display: 'inline-flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            textDecoration: 'none'
                        }}
                    >
                        {iconColor ? getIconWithColor(item.icon) : React.cloneElement(item.icon, { size: customIconSize })}
                        {showLabels && (
                            <span style={{
                                color: labelColor,
                                fontSize: '10px',
                                marginTop: '4px',
                                fontWeight: 'bold'
                            }}>
                                {item.label}
                            </span>
                        )}
                    </a>
                )
            ))}
        </Box>
    );
};